<template>
  <div class="spin_parent">
    <Table size="small" :loading="spin" :disabled-hover="true" :columns="columns" :data="data"></Table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    row: Object
  },
  data () {
    return {
      spin: false,
      data: [],
      columns: [
        { title: '编号', key: 'id' },
        { title: '序列号', key: 'sn' },
        { title: '合作伙伴', key: 'agent_name' },
        { title: '站点', key: 'site_name' },
        { title: '地址',
          key: 'address',
          render: (h, data) => {
            return h('span', {}, `${data.row.province || ''}-${data.row.city || ''}-${data.row.area || ''}`)
          } },
        { title: '操作',
          width: 120,
          key: 'operate',
          render: (h, data) => {
            return h('Button', { props: { type: 'warning', size: 'small', ghost: true },
              on: {
                click: () => {
                  this.$Modal.confirm({
                    title: '解绑活动',
                    content: `是否将活动: ${this.row.name},从该设备上解除?`,
                    onOk: () => {
                      this.unBind(data.row.id)
                    }
                  })
                }
              } }, '解绑')
          } }
      ]
    }
  },
  mounted () {
    this.spin = true
    this.getMachinesByActivity({ id: this.row.id }).then(res => {
      this.data = res
      this.spin = false
    })
  },
  methods: {
    unBind (id) {
      this.unBindMachine({ id: id }).then(res => {
        if (res) {
          this.data.map((item, index) => {
            if (item.id === id) {
              this.data.splice(index, 1)
            }
          })
        }
      })
    },
    ...mapActions(['getMachinesByActivity', 'unBindMachine'])
  }
}
</script>

<style scoped>
.spin_parent{
  position: relative;
}
.spin{
  position: absolute;
  display: inline-block;
  width: 100%;
  height: 100%;
}
</style>
